import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';

import {WorkSignifier} from '@forecast-it/design-system';
import {ProjectGroupIndicator_projectGroup$data} from './__generated__/ProjectGroupIndicator_projectGroup.graphql';

function withPrefix(companyProjectGroupId: number | null): string {
	if (!companyProjectGroupId) return '';

	return `${'X'}${companyProjectGroupId}`;
}

type ProjectIndicatorProps = {
	projectGroup: ProjectGroupIndicator_projectGroup$data;
	outline: boolean;
};
const ProjectGroupIndicator = ({projectGroup, outline}: ProjectIndicatorProps): JSX.Element => {
	if (!projectGroup) {
		return <></>; // temp fix until we fix the recent project dropdown that shows empty projects
	}
	const workId = withPrefix(projectGroup.companyProjectGroupId);

	return (
		<WorkSignifier
			workId={workId}
			name={projectGroup.name || undefined}
			color={projectGroup.color || ''}
			outline={outline}
		/>
	);
};

// Exported raw component to reuse it in ProjectIndicatorJS that wraps it in a JS fragment (since JS and TS fragments are incompatible)
export {ProjectGroupIndicator as ProjectGroupIndicatorNoFragment};

export default createFragmentContainer(ProjectGroupIndicator, {
	projectGroup: graphql`
		fragment ProjectGroupIndicator_projectGroup on ProjectGroupType {
			name
			companyProjectGroupId
			color
		}
	`,
});
